import React, { useEffect, useState } from 'react';
import { CheckCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { RequestError } from '../../../Error.model';
import { Promotion, PromotionStatus } from '../Promotion.model';
import { usePromotion } from '../PromotionContext';
import { PromotionReward } from '../PromotionReward';

interface Props {
  promotion: Promotion;
  provider: string;
  previousStep: () => void;
}

export function ClaimDirectReward({ promotion, provider, previousStep }: Props): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const { claim } = usePromotion();

  const [claimStatus, setClaimStatus] = useState<PromotionStatus>(null);
  const [errorCode, setErrorCode] = useState<string>(null);

  useEffect(() => {
    setClaimStatus(promotion.userData?.status);
  }, [promotion]);

  const claimDirect = async (): Promise<void> => {
    try {
      await claim(promotion.promotionData.promotionId, provider);
    } catch (e) {
      const err = e as RequestError;
      setErrorCode(err.code);
    }
  };

  return (
    <>
      {(!claimStatus || claimStatus === PromotionStatus.Claimable)
      && (
        <>
          <p className='claim-promotion-instructions'>
            {t('promotion.claim-reward.direct.description', {
              rewardGame: t(`games.${promotion.promotionData.relatedToGameId}`),
              provider: t(`${provider}`),
            })}
          </p>
          <div className='claim-promotion-summary'>
            {promotion.promotionData.rewards.map((reward) => (
              <PromotionReward key={reward.displayName} reward={reward} />
            ))}
          </div>
          <div className='d-flex'>
            {promotion.promotionData.redeemableOnPlatformIds.length > 1 && (
              <button
                type='button'
                className='btn btn-link mx-4'
                onClick={previousStep}
                data-cy='claim-direct-cancel-btn'
              >
                {t('common.cancel')}
              </button>
            )}
            <button
              type='submit'
              data-cy='claim-direct-confirm-btn'
              className='btn btn-primary-game mx-4'
              onClick={claimDirect}
            >
              {t('button.redeem')}
            </button>
          </div>
        </>
      )}

      {!errorCode && claimStatus === PromotionStatus.Claimed
        && (
          <>
            <CheckCircle className='icon success' />
            <h4 data-cy='claim-direct-success'>
              {t('promotion.claim-reward.direct.success-title')}
            </h4>
            <p>
              {t('promotion.claim-reward.direct.success-description', {
                rewardGame: t(`games.${promotion.promotionData.relatedToGameId}`),
              })}

            </p>
            <button
              type='button'
              className='btn btn-primary-game btn-back-home my-5'
              onClick={() => { history.push('/'); }}
              data-cy='claim-direct-home-btn'
            >
              {t('button.return-home')}
            </button>
          </>
        )}
    </>
  );
}
